import { Box, useMediaQuery } from "@mui/material";
import ContactUsForm from "components/desktop/ContactUsForm";
import { pageWidth } from "constants/pageWidth";
import { useEffect } from "react";

const ContactUs = () => {
  const isTablet = useMediaQuery("(max-width:1595px)");
  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <Box
      display="flex"
      flexDirection="column"
      width={isMobile ? "95%" : isTablet ? "85%" : pageWidth}
      maxWidth="1344px"
      margin="auto"
    >
      <ContactUsForm />
    </Box>
  );
};

export default ContactUs;
